@use '../../../scss/utility';

@use './button-vars';
@use './button-common';

:host {
  @include button-vars.wb-button-vars;
  @include button-vars.wb-button-primary-vars;
  @include button-common.wb-button;

  .button {
    @include button-common.wb-button-inner;
    @include button-common.wb-button-normalizing;
    @include utility.wb-text(
      'l',
      (
        strong: true,
        responsive: false,
      )
    );

    &:focus {
      @include button-vars.wb-button-primary-focus-vars;
    }

    &:hover:not([disabled]) {
      @include button-vars.wb-button-primary-hover-vars;
    }

    &:active:not([disabled]),
    &.active:not([disabled]) {
      @include button-vars.wb-button-primary-active-vars;
    }
  }

  .wb-spinner {
    @include button-common.wb-button-spinner;
  }
}

::slotted(.wb-icon) {
  @include button-common.wb-button-icon;
}

::slotted([slot='trailing-icon'].wb-icon) {
  @include button-common.wb-button-trailing-icon;
}

:host([disabled]) {
  @include button-common.wb-button-disabled; // for the anchor

  .button {
    cursor: not-allowed; // for the button
  }

  slot,
  .wb-spinner {
    pointer-events: none; // prevent slotted elements and wb-spinner from emitting click events
  }
}

:host([loading]) {
  pointer-events: none;
  .button {
    @include button-vars.wb-button-primary-loading-vars;
    @include button-common.wb-button-loading;
  }

  ::slotted(.wb-icon) {
    @include button-common.wb-button-loading-icon;
  }
}

:host([variant='secondary']) {
  @include button-vars.wb-button-secondary-vars;

  .button {
    &:focus {
      @include button-vars.wb-button-secondary-focus-vars;
    }

    &:hover:not([disabled]) {
      @include button-vars.wb-button-secondary-hover-vars;
    }

    &:active:not([disabled]),
    &.active:not([disabled]) {
      @include button-vars.wb-button-secondary-active-vars;
    }
  }
}

:host([variant='secondary'][loading]) {
  .button {
    @include button-vars.wb-button-secondary-loading-vars;
  }
}

:host([variant='secondary'][icon-only]) {
  .button {
    @include button-vars.wb-button-secondary-icon-only-vars;
  }
}

:host([variant='tertiary']) {
  @include button-vars.wb-button-tertiary-vars;

  .button {
    &:focus {
      @include button-vars.wb-button-tertiary-focus-vars;
    }

    &:hover:not([disabled]) {
      @include button-vars.wb-button-tertiary-hover-vars;
    }

    &:active:not([disabled]),
    &.active:not([disabled]) {
      @include button-vars.wb-button-tertiary-active-vars;
    }
  }
}

:host([variant='tertiary'][loading]) {
  .button {
    @include button-vars.wb-button-tertiary-loading-vars;
  }
}

:host([variant='tertiary'][icon-only]) {
  .button {
    @include button-vars.wb-button-tertiary-icon-only-vars;
  }
}

:host([variant='translucent']) {
  @include button-vars.wb-button-translucent-vars;

  .button {
    &:focus {
      @include button-vars.wb-button-translucent-focus-vars;
    }

    &:hover:not([disabled]) {
      @include button-vars.wb-button-translucent-hover-vars;
    }

    &:active:not([disabled]),
    &.active:not([disabled]) {
      @include button-vars.wb-button-translucent-active-vars;
    }
  }
}

:host([variant='translucent'][loading]) {
  .button {
    @include button-vars.wb-button-translucent-loading-vars;
  }
}

:host([variant='translucent'][icon-only]) {
  .button {
    @include button-vars.wb-button-translucent-icon-only-vars;
  }
}

:host([variant='destructive']) {
  @include button-vars.wb-button-destructive-vars;

  .button {
    &:focus {
      @include button-vars.wb-button-destructive-focus-vars;
    }

    &:hover:not([disabled]) {
      @include button-vars.wb-button-destructive-hover-vars;
    }

    &:active:not([disabled]),
    &.active:not([disabled]) {
      @include button-vars.wb-button-destructive-active-vars;
    }
  }
}

:host([variant='destructive'][loading]) {
  .button {
    @include button-vars.wb-button-destructive-loading-vars;
  }
}

:host([size='l']) {
  .button {
    @include button-vars.wb-button-l-vars;
  }
}

:host([size='m']) {
  .button {
    @include button-vars.wb-button-m-vars;
  }
}

:host([size='s']) {
  .button {
    @include button-vars.wb-button-s-vars;
  }
}

:host([variant='tertiary'][size='l']) .button {
  @include button-vars.wb-button-tertiary-l-vars;
}

:host([variant='tertiary'][size='m']) .button {
  @include button-vars.wb-button-tertiary-m-vars;
}

:host([variant='tertiary'][size='s']) .button {
  @include button-vars.wb-button-tertiary-s-vars;
}

:host([variant='tertiary']),
:host([icon-only]) {
  min-width: initial;
}

:host([icon-only]) .button {
  @include button-vars.wb-button-primary-icon-only-vars;
  @include button-common.wb-button-icon-only;
}

:host([icon-only][size='l']) .button {
  @include button-common.wb-button-icon-only-size-l;
}

:host([icon-only][size='m']) .button {
  @include button-common.wb-button-icon-only-size-m;
}

:host([icon-only][size='s']) .button {
  @include button-common.wb-button-icon-only-size-s;
}
